module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav-links left clearfix"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBack),
      expression: "showBack"
    }],
    attrs: {
      "href": _vm.href
    },
    on: {
      "click": _vm.go
    }
  }, [_c('ui-icon-button', {
    attrs: {
      "color": "white",
      "type": "normal",
      "icon": "arrow_back"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showBack),
      expression: "!showBack"
    }],
    staticClass: "logo"
  }, [_c('router-link', {
    staticClass: "logo-home-link",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": require("assets/img/logo-somfy.svg"),
      "alt": "Logo Somfy"
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b772f268!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BackLink.vue
// module id = 307
// module chunks = 2